// @core/api/endpoints/affiliate/create_campaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CampaignResponse,
  CreateCampaignRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Create campaign for an offer
 * Creates a new campaign with the provided data. Returns the created resource.
 */
export async function CreateCampaign(
  data: CreateCampaignRequest,
  options?: RequestOptions
): Promise<CampaignResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/campaigns`;
  const requestOptions = options;
  return client.post<CampaignResponse>(requestPath, data, requestOptions);
}
